module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKXGUdhmIqOjjg.ba780774.woff2";